<ul class="layout-menu" role="menu" aria-label="Main navigation">
    <ng-container *ngFor="let item of model; let i = index; trackBy: trackByLabel">
        <li
            app-menuitem
            *ngIf="!item.separator"
            [item]="item"
            [index]="i"
            [root]="true"
            [ngClass]="{'active': item.active}"
            id="{{ generateId(item.label) }}"
            role="none"
        ></li>

        <li *ngIf="item.separator" class="menu-separator"></li>
    </ng-container>
</ul>
